import React from 'react'
import Header from '../../Component/Header'
import Speakers from '../Speakers'
import Footer from '../../Component/Footer'

export default function LayoutSpeakers() {
    return (
        <>
            <Header />
            <Speakers />
            <Footer />
        </>
    )
}
